<template>
  <div>
    <DateRangeModal
      v-if="modalIsVisible"
      notice="Укажите даты, на основе которых сформируются данные"
      :init-dates="metricsRange.dates"
      :init-type="metricsRange.rangeType"
      @close="modalIsVisible = false"
      @save="setDateRange"
    />
    <div class="page__header">
      <h1 class="header__title">{{ title }}</h1>
      <button class="btn btn-warning btn-lg" @click="modalIsVisible = true">
        <i class="fa fa-calendar" />
      </button>
    </div>
  </div>
</template>

<script>
import DateRangeModal from '@/_shared/components/modals/DateRangeModal';
import { date } from "@/_shared/utils";
export default {
  emits: ['on-save-dates'],
  components: {
    DateRangeModal,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modalIsVisible: false,
      metricsRange: {
        dates: date.getExistenceTimeRange(),
        rangeType: '',
      },
    };
  },
  created() {
    this.$emit('on-save-dates', this.metricsRange.dates);
  },
  methods: {
    setDateRange(dates, rangeType) {
      this.metricsRange = { dates, rangeType };
      this.$emit('on-save-dates', dates);
    },
  },
};
</script>

<style scoped>
.page__header {
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  padding: 2em 0 1.5em 0;
}
.header__title {
  margin: 0;
  padding-right: 0.4em;
}
@media (max-width: 1023px) {
  .page__header {
    width: 100%;
    justify-content: center;
  }
  .header__title {
    text-align: center;
  }
}
@media (max-width: 767px) {
  .page__header {
    padding: 1em 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/user/features/personal-area/TitleWithDatesFilter.vue